import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  height: 100%;
  overflow: hidden;
  padding: 16px;
`
